import React from "react"

import { Briefcase, Table } from "lucide-react"

import Icon from "@/components/Icon"
import { PermissionGuard } from "@/components/common/PermissionGuard"
import { TabsList, TabsTrigger } from "@/components/ui/tabs"

const ApplicationsTabsList = () => {
  return (
    <TabsList className="w-full mb-4">
      <PermissionGuard resource="applications" scopes={["any", "own"]}>
        <TabsTrigger value="applications" className="flex-1">
          <Table size={16} className="mr-2" />
          Applications
        </TabsTrigger>
      </PermissionGuard>

      <PermissionGuard resource="jobs" scopes={["any"]}>
        <TabsTrigger value="jobs" className="flex-1">
          <Briefcase size={16} className="mr-2" />
          Job Postings
        </TabsTrigger>
      </PermissionGuard>

      <PermissionGuard resource="trial_blocks">
        <TabsTrigger value="trial" className="flex-1">
          <Icon name="clock" className="h-4 w-4 mr-2 text-inherit" />
          Trial Blocks
        </TabsTrigger>
      </PermissionGuard>

      <PermissionGuard resource="sessions">
        <TabsTrigger value="orientation" className="flex-1">
          <Icon name="calendarBlank" className="h-4 w-4 mr-2 text-inherit" />
          Orientation
        </TabsTrigger>
      </PermissionGuard>

      <PermissionGuard resource="sessions">
        <TabsTrigger value="vehicle" className="flex-1">
          <Icon name="truck" className="h-4 w-4 mr-2 text-inherit" />
          Vehicle Booking
        </TabsTrigger>
      </PermissionGuard>

      <PermissionGuard resource="metrics">
        <TabsTrigger value="metrics" className="flex-1">
          <Icon name="chartBar" className="h-4 w-4 mr-2 text-inherit" />
          Metrics
        </TabsTrigger>
      </PermissionGuard>
    </TabsList>
  )
}

export default ApplicationsTabsList
